export const title = '赞赏服务协议';

export const content = `
<h1>赞赏服务协议</h1>
<h3>【导 言】</h3>
《赞赏服务协议》（以下简称“本协议”）是基于PaperWonder发布的相关协议规范、规则、声明、公告、政策、活动规则等（以下统称“PaperWonder服务条款”）制定，您在使用赞赏服务（下称“本服务”）时应遵守本协议、PaperWonder服务条款。除另有说明外，本协议中的用语定义与PaperWonder服务条款一致。

<h3>【重要说明】</h3>
1. 本协议中与您的权益（可能）存在重大关系的条款（包括免除PaperWonder责任的条款、限制您权利的条款、争议解决条款及司法管辖条款等），PaperWonder提醒您，请您留意重点查阅。您认同PaperWonder已经以合理的方式进行了充分的提示，并充分履行了对于本服务的提示义务。

2. 您应当确保在使用本服务前已仔细阅读、充分理解并毫无保留地接受本协议所有条款。若您无法理解本协议部分条款的，您承诺在使用本服务前，向PaperWonder提出说明要求。若您不同意本协议中所述任何条款或其后对本协议条款的修改，则您应当立即停止使用本服务。您继续使用本服务视为同意“本协议中所述任何条款或其后对本协议条款的修改”的方式。

3. 您确认并承诺为完全民事行为能力人，有能力同意并遵守本协议，并对本协议项下的全部行为独立承担法律责任。如果您未满18周岁，请在法定监护人的陪同下阅读本协议。本协议可能存在明确禁止未成年人使用的功能或服务的条款，请着重关注。

<h3>一、 关于赞赏</h3>
1. 赞赏是PaperWonder为了鼓励达人创作优质原创内容而设立的网络增值服务。您可以通过向特定达人赞赏，来表达对该达人的喜爱与支持。PaperWonder将根据您对特定达人的赞赏数量折算赞赏收益并以米粒形式发放给达人。

2. 您知悉并确认，PaperWonder提示您已支付成功即视为您已向特定达人成功赞赏，且PaperWonder已完成本协议项下服务。

3. 达人可以通过PaperWonder官方途径，自行选择是否向赞赏用户免费提供附赠的粉丝回馈。具体粉丝回馈方式、情况、数量及展示方式等以达人实际发布及PaperWonder具体页面展示为准。

4. 您理解并同意，达人有权自行决定是否免费提供粉丝回馈以及粉丝回馈的主题、内容、更新频率等，同时，达人亦有权随时修改已提供的粉丝回馈且无需事前通知或获得您同意。

<h3>二、 如何完成赞赏</h3>
1.您可在已开通赞赏计划的达人自制内容页面，在赞赏面板通过以下两种方式完成赞赏：
（1） 选择金额或自定义金额的赞赏模式，您可以在达人的赞赏面板选择赞赏数量或自行填写赞赏数量（仅支持整数），并通过消耗相应数量豆币完成赞赏。

2. 您理解并同意，除因PaperWonder服务存在重大瑕疵导致您完全无法使用等PaperWonder违约情形、法律法规要求必须退款的或您通过客服联系PaperWonder并经PaperWonder判断后认为可以退款等情形，本服务一经完成（即成功赞赏）后不可转让或退款。

3. 您知悉并理解，不同渠道的渠道商可能根据其制定的渠道政策独立向您收取渠道费，因此您实际支付的费用可能因此而产生差异。您承诺自行注意不同渠道的费用金额，并根据本人需要选取支付渠道。

4. 您承诺将在赞赏前仔细确认被赞赏达人账号、支付账户、支付金额、赞赏内容等信息准确无误。您承诺，由于本人原因（包括但不限于账号错误、支付账户错误、操作不当、账号/支付账户存在异常情况）导致的损失由本人自行承担。

5. 您承诺您已拥有支付渠道支付账户的所有合法权利或所涉及权利的全部合法授权。您承诺有权合法、有效使用该支付账户且未侵犯任何第三方权益。

<h3>三、 未成年人保护</h3>
1. PaperWonder非常注重未成年人的保护，为此，PaperWonder可能对未成年人使用赞赏服务做相应限制（包括但不限于年龄限制、赞赏限额等）。如您为未成年人，请在监护人的陪同下阅读本协议，并在取得监护人的同意后使用赞赏服务。

2. 监护人应指导子女上网应该注意的安全问题、理性消费，如监护人同意未成年人使用赞赏即视为监护人以本人名义赞赏。监护人应对未成年人使用赞赏服务进行正确引导、监督，未成年人使用赞赏服务，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。

3. PaperWonder提醒未成年人在使用赞赏服务时，要善于网上学习，认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。

<h3>四、 免责声明</h3>
1. PaperWonder将尽最大努力向您提供于本服务有关的积极有效的支持。但由于技术局限，PaperWonder无法保证网络服务一定能满足您的全部要求（包括但不限于网络服务的及时性、安全性、准确性）。

2. 因不可抗力（鉴于互联网之特殊性质，不可抗力亦包括黑客攻击、电信部门技术调整导致之重大影响、因政府管制导致的暂时关闭、病毒侵袭等影响互联网正常运行之情形）及不可归责于PaperWonder的原因而产生的损失，PaperWonder不承担任何责任，但将尽力减少因此而给您造成的损失和影响。

3. PaperWonder对于非经PaperWonder指定途径/渠道获得的赞赏服务不承担任何义务和/或法律责任。

<h3>五、 协议变更</h3>
1. PaperWonder有权根据法律法规、监管政策、行业规范以及PaperWonder经营策略的变化调整，单方变更、中止、终止本协议内容，并在相关页面进行公布。

2. 前述内容一经在相关的页面上公布即有效代替原来的协议内容，同时PaperWonder将以适当的方式（包括但不限于弹窗、邮件、站内信、系统通知、平台通知、网站公告等）提醒您更新后的内容，以便您及时了解本协议的最新版本。

<h3>六、 禁止行为和措施</h3>
1. 您理解并承诺，在任何情况下不会实施以下任何“禁止行为”。
（1） 通过任何机器人软件、蜘蛛软件、爬虫软件等不正当方式获得赞赏量、赞赏徽章、粉丝回馈等服务或修改、操控本服务的类别、开通信息等；
（2） 利用本服务、PaperWonder或第三方渠道（包括但不限于第三方充值渠道）的规则、系统等漏洞谋取利益或进行其他不合法、不恰当的使用；
（3） 实施任何违反法律法规、本协议、PaperWonder服务条款、公序良俗和/或有损PaperWonder和/或其他第三方合法权益的行为；
（4） 实施了PaperWonder已经发布有效的其他禁止行为；
（5） 实施了其他根据法律法规、监管政策的规定或有权的政府主管机关发布的禁止行为要求。

2. 您理解并承诺，如您实施了上述“禁止行为”，PaperWonder有权单方决定对您采取以下一项或数项限制措施，上述权利的行使无期限限制。
（1） 暂时或永久封禁、限制您账号的部分或全部功能；
（2） 如您的行为造成PaperWonder实际损失的，则由您承担相应的损害赔偿责任；
（3） 如PaperWonder发现或接举报发现您的赞赏存在可疑交易、非法交易、高风险交易或交易纠纷，PaperWonder有权视情况暂停或停止向您提供服务、依法向相关部门报告，并要求您在规定时间内提供所有的交易材料证明；
（4） 如PaperWonder接到国家司法、行政主管机关或银行的合法指示（包括查询、冻结、扣划、解冻等），PaperWonder有权在不通知您的前提下自行或通过第三方按照前述指示进行处理；
（5） PaperWonder做出前述一项或多项措施无需通知您亦无需征求您意见。

3. 如发生以下情形，PaperWonder有权单方做出中止或终止本协议的全部或部分服务，上述权利的行使无期限限制。
（1） 根据法律法规、监管政策的规定或有权的政府主管机关的要求；
（2） 不可抗力（鉴于互联网之特殊性质，不可抗力亦包括黑客攻击、电信部门技术调整导致之重大影响、因政府管制导致的暂时关闭、病毒侵袭等影响互联网正常运行之情形）；
（3） 为维护账号与系统安全等紧急情况之需要的；
（4） 其他生效的规则约定PaperWonder可以做出相关措施的情形。

4. 您理解并同意，若由于达人自身原因导致其无法正常使用PaperWonder服务（包括但不限于达人违反法律法规、PaperWonder服务条款等原因导致其账号被封禁或限制功能），致使您无法访问您成功赞赏的达人页面并发布互动内容、展示赞赏徽章或使用附赠的粉丝回馈等，PaperWonder不承担不承担任何义务和/或法律责任。

<h3>七、 其它</h3>
1.本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律。本协议项下因与中华人民共和国现行法律冲突而导致部分无效，不影响其他部分的效力。

2. 如就本协议内容或执行发生任何争议，应尽量友好协商解决；协商不成时，则争议双方均一致同意将争议提交中国上海仲裁委员会按照其仲裁规则进行仲裁，仲裁裁决为一裁终局，对争议双方均有法律约束力。

3.本协议未尽事宜，或与国家、地方有关规定相悖的，按有关规定执行。
`;
